import { render, staticRenderFns } from "./MyServices.vue?vue&type=template&id=f82fa6e8&scoped=true"
import script from "./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue?vue&type=script&lang=js"
import style0 from "./MyServices.vue?vue&type=style&index=0&id=f82fa6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82fa6e8",
  null
  
)

export default component.exports